import { useLocation } from 'react-router-dom';
import { useEffect, React } from 'react';
import ContactForm from './components/ContactForm';
import Navbar from './components/Navbar';
import { Link } from 'react-router-dom';
import './styles.css';
import ScreenSize from './components/ScreenSize';  /* current screen size for different scroll offsets */

function Home() {

  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(location.state.scrollTo);
        if (el) {
          const yOffset = location.state.scrollOffset ?? -10;
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
        window.history.replaceState({}, document.title);
      }, 100);
    }
  }, [location]);


  const screenWidth = ScreenSize();   /* gets current screen width */

  const getOffset = (section) => {
    if (screenWidth <= 630) {
      return -25;
    } 
    else if (screenWidth <= 960) {
      return -150;
    } 
    else {
      return -350;
    }
  };


  return (
    <div>
      {/* Navbar Section */}
      <Navbar />

      {/* Main Section */}
      <div id="home" className="main">
        <div className="main__container">
          <div className="main__content-name">
            <h1>Mia Liu</h1>
          </div>
          <div className="main__content-desc">            
            <h1>Artist, designer, developer.<br />
            Lover of creativity and expression. ♡</h1>
            <button onClick={() => {
              const target = document.getElementById("portfolios");
              const offset = getOffset();
              const targetPosition = target.getBoundingClientRect().top + window.scrollY + offset;
              window.scrollTo({ top: targetPosition, behavior: "smooth" });
            }}>
              view my work
            </button>
          </div>
        </div>
      </div>

      {/* Portfolios Section */}
      <div id="portfolios" className="portfolios">
          <div className="portfolios__container" style={{ position: 'relative' }}>
            <Link to="/fashion" className="portfolios__card">
              <h2>fashion<br />
                <span>portfolio</span>
              </h2>
            </Link>
            <Link to="/art" className="portfolios__card">
              <h2>artwork<br />
                <span>portfolio</span>
              </h2>
            </Link>
            <Link to="/gamedev" className="portfolios__card">
              <h2>game dev<br />
                <span>portfolio</span>
              </h2>
            </Link>
            {/* <div class="arrowPortfolio bounce"></div> */} 
          </div>
      </div>

      {/* About Section */}
      <div id="about" className="about">
        <div className="about__container" style={{ position: 'relative' }}>
          <div className="about__image">
            <img src="images/home_page/about-section.jpg" alt="About"/>
          </div>
        <div className="about__desc">            
            <h1>Hi! My name is Mia Liu.</h1>
            <p>I am a senior undergraduate student at UCLA pursing a Bachelor of Science in Cognitive Science and a minor in Data Science Engineering.</p>
            <p>My interests include fashion design, computer science, art, and product design.</p>
            <p>With over nine years of experience in sewing and design, I started my sewing journey in elementary school by dressing up my stuffed animals. Since then, my passion has evolved into creating custom garments, gowns, and a runway collection.</p>
            <p>I was a designer for the FAST at UCLA 2024 runway, and am currently the Technician Supervisor at the UCLA Makerspace.</p>
        </div>
          {/* <div class="arrowAbout bounce"></div> */}
        </div>
      </div>

      {/* Contact Form */}
      <div id="contact" className="contact">
        <ContactForm />
        <div className="contact__container">
          <div className="contact__image">
            <img src="images/home_page/contact-section.jpg" alt="Contact"/>
          </div>
        </div>
      </div>

      {/* Footer Section */}
      <div className="footer__container">
        <div className="websiteRights">
          <p>© MINYA 2025 | all rights reserved</p>
        </div>
        <div className="footerCredits">
          <p>Main homepage image by @digitalpix.ie, modified by Mia Liu.</p>
          <p>All other images by Mia Liu.</p>
        </div>
      </div>

    </div>
  );
}

export default Home;
